import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { HeroTypes, HeroV2 } from '../../models';
import { AppComponent } from '../../app.component';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { RemoteConfigService } from '../../services/remote-config.service';

@Component({
    selector: 'app-hero-carousel-banner-smart-tv',
    templateUrl: './hero-carousel-banner-smart-tv.component.html',
    styleUrls: ['./hero-carousel-banner-smart-tv.component.scss']
})
export class HeroCarouselBannerSmartTvComponent implements OnInit, AfterViewInit, OnDestroy {

    heroWeb: string;
    logo: string;
    titleText: string;

    destroy = new Subject<void>();

    width: number = 0;

    @Input() heroItem: HeroV2;
    @Input() dpadStart = false;
    @Input() bannerId: string;

    @Output() focused = new EventEmitter<void>();

    @ViewChild('banner') banner;

    constructor(private app: AppComponent,
                private router: Router,
                private changeDetector: ChangeDetectorRef,
                public config: RemoteConfigService) {
    }

    ngOnInit(): void {
        if (this.heroItem.images) {
            this.heroWeb = this.heroItem.images.find(f => f.type === 'hero-web')?.url ?? this.heroWeb;
            this.logo = this.heroItem.images.find(f => f.type === 'logo')?.url ?? this.logo;
        }

        if (this.heroItem.text) {
            this.titleText = this.heroItem.text.find(f => f.type === 'title')?.text ?? this.titleText;
        }
    }

    ngAfterViewInit() {
        this.width = Math.ceil(this.banner?.nativeElement.offsetWidth);
        this.changeDetector.detectChanges();
    }

    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
    }

    isAuthenticated() {
        return this.app.isAuthenticated();
    }

    navigate() {
        switch (this.heroItem.type) {
            case HeroTypes.LatestPlayer:
                this.router.navigate(['/video', this.heroItem.media.mediaId]);
                break;
            case HeroTypes.ExternalLink:
                window.open(this.heroItem.redirectUrl, '_blank').focus();
                break;
            case HeroTypes.InternalLink:
                this.router.navigate([this.heroItem.redirectUrl]);
                break;
            case HeroTypes.Show:
                if (this.heroItem.seasonId) {
                    this.router.navigate(['/season', this.heroItem.seasonId]);
                } else {
                    this.router.navigate(['/shows', this.heroItem.channelId]);
                }
                break;
            case HeroTypes.Media:
                this.router.navigate(['/video', this.heroItem.mediaId]);
                break;
            case HeroTypes.Creator:
                this.router.navigate(['/creators', this.heroItem.creatorTeamId]);
                break;
        }
    }
}
